<template>
  <page title="Create new coupon" backTo="/magazine/coupons" size="is-desktop">
    <form @submit.prevent="handleSubmit" v-if="form">
      <div class="columns">
        <div class="column is-4">
          <div class="box">
            <b-field label="Usage type">
              <b-select placeholder="Required field" expanded v-model="form.usage_type">
                <option value="limited">limited</option>
                <option value="unlimited">unlimited</option>
              </b-select>
            </b-field>

            <hr/>

            <b-field label="Type">
              <b-select placeholder="Required field" expanded v-model="form.type">
                <option value="issue">issue</option>
                <option value="subscription">subscription</option>
                <option value="gold">gold</option>
              </b-select>
            </b-field>
          </div>

          <div class="box">
            <b-field label="Max users count">
              <b-input type="number" v-model="form.max_users_count"></b-input>
            </b-field>
          </div>
        </div>

        <div class="column is-8">
          <div class="box">
            <b-field label="Coupon code">
              <b-input v-model="form.code" placeholder="Required field"></b-input>
            </b-field>
            <div class="columns">
              <div class="column is-6">
                <b-field label="Expiry date">
                  <b-datepicker
                    placeholder="Can be nullable"
                    icon="calendar-today"
                    v-model="form.expiry_date"
                    editable>
                  </b-datepicker>
                </b-field>
              </div>

              <div class="column is-6">
                <b-field label="Quantity">
                  <b-input type="number" placeholder="Required field" v-model="form.quantity"></b-input>
                </b-field>
              </div>
            </div>
          </div>

          <div class="box">
            <b-button position="is-bottom-left">Add new </b-button>
          </div>
        </div>
      </div>

      <hr />

      <div class="is-pulled-right">
        <router-link to="/magazine/coupons" class="button" :disabled="form.processing">Cancel</router-link>

        <button class="button is-primary" :class="{ 'is-loading': form.processing }">
          <b-icon icon="content-save"></b-icon>
          <span>Save</span>
        </button>
      </div>
    </form>
  </page>
</template>

<script>

export default {
  data() {
    return {
      form: new window.Form({
        usage_type: null,
        type: null,
        code: null,
        max_users_count: null,
        expiry_date: null,
        quantity: null,
        subscription_months: null
      }),
    };
  },

  methods: {
    handleSubmit() {
      this.form.post(`/admin/api/coupons`).then(() => {
        this.$buefy.toast.open({
          type: "is-success",
          message: "Successfully saved."
        });

        this.$emit("saved", this.form);
        this.$router.push("/magazine/coupons");
      });
    },
  }
};
</script>
